import { useNavigate } from 'react-router';

export const logOut = async () => {
  console.log('Start');

  const navigate = useNavigate();
  navigate('/login');
  console.log('Finish');
};
